var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReproducibleAnalysesWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "185px",
    height: "113px",
    viewBox: "0 0 185 113",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Reproducible Analyses") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Landing-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-494.000000, -496.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(494.000000, 496.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#0F91F2",
    strokeWidth: 4.3,
    x: 2.15,
    y: 28.15,
    width: 146.7,
    height: 82.7,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(13.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#0F91F2",
    strokeWidth: 4.3,
    fill: "#FFFFFF",
    x: 2.15,
    y: 2.15,
    width: 146.7,
    height: 82.7,
    rx: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 16.5,
    x2: 47,
    y2: 16.5,
    id: "Line-2",
    stroke: "#0F91F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 41.5,
    x2: 133,
    y2: 41.5,
    id: "Line-2-Copy-3",
    stroke: "#0F91F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.491453,
    y1: 25.5,
    x2: 134,
    y2: 26,
    id: "Line-2-Copy-2",
    stroke: "#0F91F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 49.5,
    x2: 133,
    y2: 49.5,
    id: "Line-2-Copy-4",
    stroke: "#0F91F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 66.5,
    x2: 133,
    y2: 66.5,
    id: "Line-2-Copy-5",
    stroke: "#0F91F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    stroke: "#0F91F2",
    strokeWidth: 4,
    x: 19,
    y: 39,
    width: 78,
    height: 31,
    rx: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.189747,
    y1: 67,
    x2: 94.161578,
    y2: 42,
    id: "Path-10",
    stroke: "#0F91F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,54.5014153 C43,56.4346947 41.4318641,58 39.4985847,58 C37.5681359,58 36,56.4346947 36,54.5014153 C36,52.5681359 37.5681359,51 39.4985847,51 C41.4318641,51 43,52.5681359 43,54.5014153",
    id: "Fill-1",
    fill: "#FF5B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,61.5014153 C34,63.4346947 32.4318641,65 30.4985847,65 C28.5681359,65 27,63.4346947 27,61.5014153 C27,59.5681359 28.5681359,58 30.4985847,58 C32.4318641,58 34,59.5681359 34,61.5014153",
    id: "Fill-1-Copy-5",
    fill: "#FF5B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,58.5014153 C75,60.4346947 73.4318641,62 71.4985847,62 C69.5681359,62 68,60.4346947 68,58.5014153 C68,56.5681359 69.5681359,55 71.4985847,55 C73.4318641,55 75,56.5681359 75,58.5014153",
    id: "Fill-1-Copy-3",
    fill: "#FF5B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,46.5014153 C82,48.4346947 80.4318641,50 78.4985847,50 C76.5681359,50 75,48.4346947 75,46.5014153 C75,44.5681359 76.5681359,43 78.4985847,43 C80.4318641,43 82,44.5681359 82,46.5014153",
    id: "Fill-1-Copy-4",
    fill: "#FF5B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,52.5014153 C61,54.4346947 59.4318641,56 57.4985847,56 C55.5681359,56 54,54.4346947 54,52.5014153 C54,50.5681359 55.5681359,49 57.4985847,49 C59.4318641,49 61,50.5681359 61,52.5014153",
    id: "Fill-1-Copy-2",
    fill: "#FF5B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,51.5014153 C70,53.4346947 68.4318641,55 66.4985847,55 C64.5681359,55 63,53.4346947 63,51.5014153 C63,49.5681359 64.5681359,48 66.4985847,48 C68.4318641,48 70,49.5681359 70,51.5014153",
    id: "Fill-1-Copy-6",
    fill: "#FF5B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,61.5014153 C53,63.4346947 51.4318641,65 49.4985847,65 C47.5681359,65 46,63.4346947 46,61.5014153 C46,59.5681359 47.5681359,58 49.4985847,58 C51.4318641,58 53,59.5681359 53,61.5014153",
    id: "Fill-1-Copy",
    fill: "#FF5B00"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#0F91F2",
    strokeWidth: 4.3,
    x: 2.15,
    y: 28.15,
    width: 146.7,
    height: 82.7,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(13.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#0F91F2",
    strokeWidth: 4.3,
    fill: "#FFFFFF",
    x: 2.15,
    y: 2.15,
    width: 146.7,
    height: 82.7,
    rx: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 16.5,
    x2: 47,
    y2: 16.5,
    id: "Line-2",
    stroke: "#0F91F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 41.5,
    x2: 133,
    y2: 41.5,
    id: "Line-2-Copy-3",
    stroke: "#0F91F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.491453,
    y1: 25.5,
    x2: 134,
    y2: 26,
    id: "Line-2-Copy-2",
    stroke: "#0F91F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 49.5,
    x2: 133,
    y2: 49.5,
    id: "Line-2-Copy-4",
    stroke: "#0F91F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 66.5,
    x2: 133,
    y2: 66.5,
    id: "Line-2-Copy-5",
    stroke: "#0F91F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    stroke: "#0F91F2",
    strokeWidth: 4,
    x: 19,
    y: 39,
    width: 78,
    height: 31,
    rx: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.189747,
    y1: 67,
    x2: 94.161578,
    y2: 42,
    id: "Path-10",
    stroke: "#0F91F2",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,54.5014153 C43,56.4346947 41.4318641,58 39.4985847,58 C37.5681359,58 36,56.4346947 36,54.5014153 C36,52.5681359 37.5681359,51 39.4985847,51 C41.4318641,51 43,52.5681359 43,54.5014153",
    id: "Fill-1",
    fill: "#FF5B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,61.5014153 C34,63.4346947 32.4318641,65 30.4985847,65 C28.5681359,65 27,63.4346947 27,61.5014153 C27,59.5681359 28.5681359,58 30.4985847,58 C32.4318641,58 34,59.5681359 34,61.5014153",
    id: "Fill-1-Copy-5",
    fill: "#FF5B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,58.5014153 C75,60.4346947 73.4318641,62 71.4985847,62 C69.5681359,62 68,60.4346947 68,58.5014153 C68,56.5681359 69.5681359,55 71.4985847,55 C73.4318641,55 75,56.5681359 75,58.5014153",
    id: "Fill-1-Copy-3",
    fill: "#FF5B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,46.5014153 C82,48.4346947 80.4318641,50 78.4985847,50 C76.5681359,50 75,48.4346947 75,46.5014153 C75,44.5681359 76.5681359,43 78.4985847,43 C80.4318641,43 82,44.5681359 82,46.5014153",
    id: "Fill-1-Copy-4",
    fill: "#FF5B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,52.5014153 C61,54.4346947 59.4318641,56 57.4985847,56 C55.5681359,56 54,54.4346947 54,52.5014153 C54,50.5681359 55.5681359,49 57.4985847,49 C59.4318641,49 61,50.5681359 61,52.5014153",
    id: "Fill-1-Copy-2",
    fill: "#FF5B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,51.5014153 C70,53.4346947 68.4318641,55 66.4985847,55 C64.5681359,55 63,53.4346947 63,51.5014153 C63,49.5681359 64.5681359,48 66.4985847,48 C68.4318641,48 70,49.5681359 70,51.5014153",
    id: "Fill-1-Copy-6",
    fill: "#FF5B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,61.5014153 C53,63.4346947 51.4318641,65 49.4985847,65 C47.5681359,65 46,63.4346947 46,61.5014153 C46,59.5681359 47.5681359,58 49.4985847,58 C51.4318641,58 53,59.5681359 53,61.5014153",
    id: "Fill-1-Copy",
    fill: "#FF5B00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy",
    transform: "translate(137.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#1A1A1A",
    cx: 23.9555556,
    cy: 23.9555556,
    r: 23.9555556
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(13.688889, 6.844444)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 2.93333333,
    strokeLinejoin: "round",
    x: 0,
    y: 11.7333333,
    width: 21.5111111,
    height: 17.6,
    rx: 2.93333333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7555556,1.46666667 C12.1055849,1.46666667 13.3278072,2.01387419 14.212522,2.89858907 C15.0972369,3.78330394 15.6444444,5.00552617 15.6444444,6.35555556 L15.6444444,6.35555556 L15.6444444,10.7555556 L6.35555556,11.2444444 L5.86666667,6.35555556 C5.86666667,5.00552617 6.41387419,3.78330394 7.29858907,2.89858907 C8.18330394,2.01387419 9.40552617,1.46666667 10.7555556,1.46666667 Z",
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 2.93333333
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(8.311111, 16.622222)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 2.44444444,
    cy: 2.44444444,
    r: 2.44444444
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.44444444,
    y1: 3.42222222,
    x2: 2.44444444,
    y2: 7.33333333,
    id: "Line",
    stroke: "#FFFFFF",
    strokeWidth: 2.93333333,
    strokeLinecap: "round"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReproducibleAnalysesWhite);
export default __webpack_public_path__ + "static/media/icon-reproducible-analyses-white.84119023.svg";
export { ForwardRef as ReactComponent };